import { useSearchParams, Link, useLocation } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import TermGuidelineCategory from '@/components/TermGuidelineCategory';

const QualityGuidelinePSAPage = () => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const isMobile = searchParams.get('isMobile') === '1' || searchParams.get('isMobile') === 'true';

  return (
    <div className="w-full bg-white min-h-screen flex flex-col">
      {!isMobile && <Header />}
      
      <div className="w-full bg-white inline-flex justify-center overflow-hidden">
        <div className="container pt-10 pb-20 px-4 md:px-0 flex flex-col justify-start items-start gap-[60px] overflow-hidden">
          <div className="w-full flex flex-col justify-start items-start gap-2.5">
            <div className="justify-center text-black text-[40px] font-bold leading-[60px]">クオリティガイドライン - PSA</div>
            <div className="h-[3px] w-full relative bg-[#e4e4e4]" />
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">出品条件</div>
            </div>
            <div className="justify-center">
              <span className="text-black text-base font-normal leading-7">以下のような状態の商品の出品が可能です。<br/></span>
              <span className="text-black text-base font-normal leading-7">・ホルダーに開封された形跡がない<br/>・ホルダーに破損がない<br/>・ホルダー自体が偽造されていない<br/></span>
              <span className="text-black text-base font-normal leading-7">※カード本体（ホルダー内部）の状態や真贋については、各鑑定機関の結果を尊重し、DONDONでは確認いたしません。<br/>※透明なプラスチック製のOPP袋に入っている場合は、鑑定時に袋を開封し、状態に応じてDONDONにて新しい袋へ交換いたします。</span>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">注意事項</div>
            </div>
            <div className="flex flex-col justify-start items-start gap-2.5">
              <div className="justify-center">
                <span className="text-black text-base font-normal leading-7">・ガイドラインに記載されている内容はあくまで一例であり、商品ごとに状態レベルの基準が変動する場合があります。<br/>・掲載されている商品画像は、撮影環境などの影響により、実物と色味が異なって見えることがあります。<br/>・商品の検品時には、選択された商品状態がガイドラインの基準と一致しているかを確認しております。<br/>・補足説明に記載された内容よりも、ガイドラインで定められた基準が優先されます。<br/></span>
                <span className="text-black text-base font-normal leading-7">※なお、商品状態にかかわらず、購入者様に誤解を与えるような表現や、出品情報と大きく異なる内容が記載されている場合は、取引がキャンセルとなる可能性があります。</span>
              </div>
              <div className="flex flex-col justify-start items-start">
                <div className="justify-center text-black text-base font-normal leading-7">すべての出品に共通するルールや、出品情報に関する詳細については、以下のページもあわせて必ずご確認ください。</div>
                <Link to={`/terms/guideline_listing${location.search}`} className="justify-center text-[#00b8f9] text-base font-normal underline leading-7 hover:text-[#0099d6]">出品ガイドライン</Link>
              </div>
            </div>
          </div>
          
          <div className="self-stretch flex flex-col justify-start items-start gap-[30px]">
            <div className="px-[5px] inline-flex justify-start items-center gap-2.5">
              <div className="w-0 h-[27.50px] border-[#e4e4e4] border-2 rounded-xl" />
              <div className="justify-center text-black text-2xl font-bold leading-9">商品の状態</div>
            </div>
            
            <div className="w-full flex flex-col justify-start items-start gap-5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">基準内</div>
              <div className="flex flex-col justify-start items-start gap-2.5">
                <div className="justify-center text-black text-base font-normal leading-7">軽微なキズやホルダー内部の気泡の混入については、製造や流通の過程で生じることがあるため、基準内の状態として取り扱っております。<br/>ただし、目立つキズや複数箇所にわたる場合には、該当箇所がわかるように商品画像を追加し、補足説明欄にもその旨をご記載ください。</div>
              </div>
              <div className="self-stretch inline-flex justify-between items-center">
                <div className="inline-flex flex-col justify-start items-start gap-2.5 w-1/2 pr-2">
                  <div className="justify-center text-black text-base font-bold leading-7">・ホルダーの内部に気泡、埃や屑などの粒子</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_psa_1.jpg" alt="ホルダーの内部に気泡、埃や屑などの粒子" />
                </div>
                <div className="inline-flex flex-col justify-start items-start gap-2.5 w-1/2 pl-2">
                  <div className="justify-center text-black text-base font-bold leading-7">・ホルダーに軽微な傷</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_psa_2.jpg" alt="ホルダーに軽微な傷" />
                </div>
              </div>
            </div>
            
            <div className="h-[2px] w-full relative bg-[#e4e4e4]" />
            
            <div className="w-full flex flex-col justify-start items-start gap-5">
              <div className="justify-center text-black text-xl font-bold leading-[30px]">基準外</div>
              <div className="self-stretch inline-flex justify-between items-center">
                <div className="inline-flex flex-col justify-start items-start gap-2.5 w-1/2 pr-2">
                  <div className="justify-center text-black text-base font-bold leading-7">・ホルダー表面に大きな傷</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_psa_3.png" alt="ホルダー表面に大きな傷" />
                </div>
                <div className="inline-flex flex-col justify-start items-start gap-2.5 w-1/2 pl-2">
                  <div className="justify-center text-black text-base font-bold leading-7">・ホルダーにひび割れ</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_psa_4.jpg" alt="ホルダーにひび割れ" />
                </div>
              </div>
              <div className="self-stretch inline-flex justify-between items-start">
                <div className="inline-flex flex-col justify-start items-start gap-2.5 w-1/2 pr-2">
                  <div className="justify-center text-black text-base font-bold leading-7">・ホルダーに破損や欠け</div>
                  <img className="w-full h-auto" src="/images/terms/guideline_psa_5.jpg" alt="ホルダーに破損や欠け" />
                </div>
                <div className="w-1/2 pl-2" />
              </div>
            </div>
          </div>
          
          <TermGuidelineCategory />
        </div>
      </div>
      
      {!isMobile && <Footer />}
    </div>
  );
};

export default QualityGuidelinePSAPage;